(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-a-video"] && !Shopify.designMode) return;
  try {
    
  /* 若需要可在此扩展交互逻辑。当前使用原生 <video> / video_tag 已满足大多数需求。*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-announcement-bar"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sm-faithful-announcement'))customElements.define('sm-faithful-announcement',class extends HTMLElement{
 connectedCallback(){queueMicrotask(()=>{if(this.controller||!this.isConnected)return;this.controller=new AbortController();const on=(t,n,f)=>t.addEventListener(n,f,{signal:this.controller.signal});const list=this.querySelector('ul'),slides=[...list.children].filter(x=>!x.hasAttribute('data-clone'));let index=0;const mobile=()=>matchMedia('(max-width:768px)').matches;const pause=()=>{this.setAttribute('data-paused','')},resume=()=>{this.removeAttribute('data-paused')};on(this,'mouseenter',pause);on(this,'mouseleave',resume);on(this,'focusin',pause);on(this,'focusout',e=>{if(!this.contains(e.relatedTarget))resume()});this.editorSelected=false;
 const setup=()=>{list.querySelectorAll('[data-clone]').forEach(x=>x.remove());list.style.transform='';if(mobile()&&slides.length>1){const width=slides.reduce((total,s)=>total+s.getBoundingClientRect().width,0);this.style.setProperty('--sm-marquee-width',width+'px');this.style.setProperty('--sm-marquee-time',Math.max(15,width/45)+'s');slides.forEach(s=>{const clone=s.cloneNode(true);clone.setAttribute('data-clone','');clone.setAttribute('aria-hidden','true');clone.querySelectorAll('a').forEach(a=>a.tabIndex=-1);list.append(clone)})}else{list.style.transform=`translateY(-${index*(slides[0]?.offsetHeight||0)}px)`}};
 on(window,'resize',setup);on(document,'shopify:block:select',e=>{const slide=e.target.closest('.yl-css-slide');if(!slide||!this.contains(slide))return;this.editorSelected=true;pause();index=slides.indexOf(slide);list.style.animation='none';list.style.transform=mobile()?`translateX(-${slide.offsetLeft}px)`:`translateY(-${index*slide.offsetHeight}px)`});on(document,'shopify:block:deselect',()=>{this.editorSelected=false;list.style.animation='';resume();setup()});this.timer=setInterval(()=>{if(mobile()||slides.length<2||this.hasAttribute('data-paused')||document.hidden||matchMedia('(prefers-reduced-motion:reduce)').matches)return;index=(index+1)%slides.length;list.style.transform=`translateY(-${index*slides[0].offsetHeight}px)`},Math.max(1000,Number(this.dataset.delay)||3000)+(Number(this.dataset.speed)||300));setup();});}
 disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.controller=null;this.querySelectorAll('[data-clone]').forEach(x=>x.remove());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-collection-explorer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sm-faithful-explorer')) customElements.define('sm-faithful-explorer', class extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController(); const signal = this.controller.signal;
    this.index = 0; this.detail = false; this.cards = [...this.querySelectorAll('[data-explorer-image]')]; this.tabs = [...this.querySelectorAll('[data-explorer-tab]')];
    this.addEventListener('click', event => {
      const tab = event.target.closest('[data-explorer-tab]'), step = event.target.closest('[data-explorer-step]'), picture = event.target.closest('[data-explorer-image]');
      if (tab) this.select(Number(tab.dataset.explorerTab)); if (step) this.select(this.index + Number(step.dataset.explorerStep));
      if (event.target.closest('[data-explorer-open]') || (picture && Number(picture.dataset.explorerImage) === this.index)) this.showDetail(true);
      if (event.target.closest('[data-explorer-back]')) this.showDetail(false);
      const arrow = event.target.closest('[data-product-step]'); if (arrow) { const track = arrow.closest('.swiper').querySelector('[data-explorer-products]'); track.scrollBy({left: Number(arrow.dataset.productStep) * track.clientWidth, behavior: this.reduced() ? 'instant' : 'smooth'}); }
      if (event.target.closest('.toggle-music')) { const audio = this.querySelector('audio'), button = this.querySelector('.toggle-music'); if (audio.paused) audio.play().then(() => button.setAttribute('aria-pressed','true')).catch(() => button.setAttribute('aria-pressed','false')); else {audio.pause(); button.setAttribute('aria-pressed','false');} }
    }, {signal});
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.detail) { this.showDetail(false); this.tabs[this.index]?.focus(); }
      if (!event.target.matches('[role=tab]')) return;
      const index = {ArrowRight:this.index+1,ArrowLeft:this.index-1,Home:0,End:this.cards.length-1}[event.key];
      if (index !== undefined) {event.preventDefault(); this.select(index); this.tabs[this.index]?.focus();}
    }, {signal});
    this.addEventListener('pointerdown', event => {this.pointerStart = {x:event.clientX,y:event.clientY};}, {signal,passive:true});
    this.addEventListener('pointerup', event => { if (event.pointerType === 'mouse' || this.detail || !this.pointerStart) return; const dx=event.clientX-this.pointerStart.x,dy=event.clientY-this.pointerStart.y; if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy)*1.5)this.select(this.index+(dx<0?1:-1)); }, {signal,passive:true});
    this.addEventListener('pointermove', event => {if (this.reduced() || this.detail || event.pointerType !== 'mouse') return; const box=this.getBoundingClientRect(),card=this.cards[this.index];card?.style.setProperty('--offset-x',(event.clientX-box.left-box.width/2)*.012+'px');card?.style.setProperty('--offset-y',(event.clientY-box.top-box.height/2)*.012+'px');}, {signal,passive:true});
    document.addEventListener('shopify:block:select', event => {const panel=event.target.closest('[data-explorer-text]');if(panel&&this.contains(panel))this.select(Number(panel.dataset.explorerText));}, {signal});
    this.resize=new ResizeObserver(() => this.style.setProperty('--util-width',this.clientWidth/100+'px'));this.resize.observe(this);this.select(0);
  }
  reduced(){return matchMedia('(prefers-reduced-motion: reduce)').matches;}
  select(index) {
    if(!this.cards.length)return;this.index=(index+this.cards.length)%this.cards.length;this.showDetail(false);
    this.cards.forEach((card,i)=>{const offset=(i-this.index+this.cards.length)%this.cards.length;card.classList.remove('slide-1','slide-2','slide-3');if(offset<3)card.classList.add('slide-'+(offset+1));card.tabIndex=offset===0?0:-1;card.setAttribute('aria-hidden',String(offset!==0));card.style.visibility=offset<3?'visible':'hidden';});
    this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===this.index));tab.tabIndex=i===this.index?0:-1;});
    this.querySelectorAll('[data-explorer-text]').forEach((panel,i)=>{panel.hidden=i!==this.index;if(i===this.index&&!this.reduced())panel.animate([{opacity:0,transform:'translateY(calc(-50% + 20px))'},{opacity:1,transform:'translateY(-50%)'}],{duration:700});});
    this.querySelector('.now-page').textContent=String(this.index+1).padStart(2,'0');
  }
  showDetail(show) {
    this.detail=show;this.classList.toggle('is-detail',show);
    this.querySelectorAll('[data-explorer-detail]').forEach((panel,i)=>{panel.hidden=!(show&&i===this.index);panel.classList.toggle('context-box-2-show',show&&i===this.index);});
    this.querySelectorAll('[data-explorer-text]').forEach((panel,i)=>{panel.hidden=show||i!==this.index;});
    if(show)this.querySelector('[data-explorer-back]').focus();
  }
  disconnectedCallback(){this.controller?.abort();this.controller=null;this.resize?.disconnect();this.querySelector('audio')?.pause();this.querySelector('video')?.pause();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-product-loading-video"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sm-faithful-video'))customElements.define('sm-faithful-video',class extends HTMLElement{
 connectedCallback(){if(this.controller)return;this.controller=new AbortController();const signal=this.controller.signal,video=this.querySelector('[data-desktop]');let queued=false;const update=()=>{if(queued)return;queued=true;this.frame=requestAnimationFrame(()=>{queued=false;if(matchMedia('(max-width:768px),(prefers-reduced-motion:reduce)').matches||!Number.isFinite(video.duration))return;const box=this.getBoundingClientRect(),progress=Math.max(0,Math.min(1,-box.top/Math.max(1,box.height-innerHeight)));if(!video.seeking&&Math.abs(video.currentTime-video.duration*progress)>.05)video.currentTime=Math.min(video.duration-.01,video.duration*progress);});};window.addEventListener('scroll',update,{signal,passive:true});window.addEventListener('resize',update,{signal,passive:true});video.addEventListener('loadedmetadata',update,{signal});video.addEventListener('seeked',update,{signal});update();}
 disconnectedCallback(){this.controller?.abort();this.controller=null;cancelAnimationFrame(this.frame);this.querySelectorAll('video').forEach(video=>video.pause());}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-series-navigation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('sm-faithful-nav'))customElements.define('sm-faithful-nav',class extends HTMLElement{
 connectedCallback(){queueMicrotask(()=>{if(!this.isConnected||this.controller)return;this.controller=new AbortController();const on=(t,n,f,o={})=>t.addEventListener(n,f,{...o,signal:this.controller.signal});const track=this.querySelector('.collection-img-wrapper'),slides=[...this.querySelectorAll('.collection-img-slide')],left=this.querySelector('.collection-img-left-arrow'),right=this.querySelector('.collection-img-right-arrow'),dropdown=this.querySelector('.collection-mobile-dropdown'),toggle=this.querySelector('.dropdown-toggle'),menu=this.querySelector('.dropdown-menu'),slot=this.querySelector('.collection-mobile-slot');const reduced=()=>matchMedia('(prefers-reduced-motion:reduce)').matches;const close=()=>{menu.hidden=true;toggle.setAttribute('aria-expanded','false')};const state=()=>{left.disabled=track.scrollLeft<2;right.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};const move=direction=>{const slide=slides[0];if(slide)track.scrollBy({left:direction*(slide.getBoundingClientRect().width+parseFloat(getComputedStyle(slide).marginRight||0)),behavior:reduced()?'instant':'smooth'})};on(left,'click',()=>move(-1));on(right,'click',()=>move(1));on(track,'scroll',state,{passive:true});on(toggle,'click',()=>{menu.hidden=!menu.hidden;toggle.setAttribute('aria-expanded',String(!menu.hidden))});on(document,'click',e=>{if(!dropdown.contains(e.target))close()});on(this,'keydown',e=>{if(e.key==='Escape'){close();toggle.focus()}});
 const headerBottom=()=>{const header=document.querySelector('sm-faithful-header .site-header,sticky-header');if(!header)return 48;const b=header.getBoundingClientRect();return b.bottom>0&&b.top<=1?Math.round(b.bottom):0};
 const sticky=()=>{const mobile=matchMedia('(max-width:768px)').matches&&this.dataset.mobileMode!=='slider';const top=headerBottom();this.style.setProperty('--sm-nav-top',top+'px');const stuck=mobile&&slot.getBoundingClientRect().top<=top;slot.style.height=stuck?dropdown.offsetHeight+'px':'';dropdown.classList.toggle('sticky',stuck)};
 on(this,'click',event=>{const mobileLink=event.target.closest('.dropdown-menu a'),slide=event.target.closest('.collection-img-slide');if(!mobileLink&&!slide)return;const index=Number((mobileLink||slide).dataset.index);const mobile=matchMedia('(max-width:768px)').matches;const targetId=mobileLink?.dataset.targetId||(mobile?slide.dataset.mobileTargetId||slide.dataset.targetId:slide.dataset.targetId);const selected=slides[index];document.dispatchEvent(new CustomEvent('thumbnail:select',{detail:{targetId,targetIndex:index,targetImage:selected?.dataset.imageSrc||'',sourceSectionId:this.dataset.sectionId},bubbles:true,cancelable:true}));if(targetId){event.preventDefault();const target=window.SubmiHome?.target(targetId)||document.getElementById(targetId.replace(/^#/,''));if(target){const stickyHeader=document.querySelector('sm-faithful-header[data-sticky=true] .header-wrapper');const offset=(stickyHeader?.offsetHeight||headerBottom())+(mobile&&this.dataset.mobileMode!=='slider'?dropdown.offsetHeight:0)+12;window.scrollTo({top:Math.max(0,scrollY+target.getBoundingClientRect().top-offset),behavior:reduced()?'instant':'smooth'})}}else if(mobileLink)event.preventDefault();close()});
 on(document,'shopify:block:select',event=>{const slide=event.target.closest('.collection-img-slide');if(slide&&this.contains(slide))track.scrollTo({left:slide.offsetLeft,behavior:'instant'})});on(window,'resize',()=>{state();sticky()});on(window,'scroll',sticky,{passive:true});this.observer=new ResizeObserver(()=>{state();sticky()});this.observer.observe(track);state();sticky();});}
 disconnectedCallback(){this.controller?.abort();this.controller=null;this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["submi-vanguard-story"]) return;
  try {
    

function initVanguard(root){
 if(!root||root.dataset.vgReady)return;
 root.dataset.vgReady='true';
 const main=root.querySelector('#vg-main-image');
 root.querySelectorAll('[data-vg-gallery]').forEach(button=>button.addEventListener('click',()=>{
  main.src=button.dataset.vgGallery;main.alt=button.getAttribute('aria-label');
  root.querySelectorAll('[data-vg-gallery]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 }));
 const dialog=root.querySelector('[data-vg-dialog]');
 root.querySelector('[data-vg-zoom]')?.addEventListener('click',()=>{const enlarged=dialog.querySelector('[data-vg-lightbox-image]');enlarged.src=main.src;enlarged.alt=main.alt;dialog.showModal();});
 root.querySelector('[data-vg-close]')?.addEventListener('click',()=>dialog.close());
 dialog?.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
 const scenes=root.querySelector('[data-vg-scenes]');
 const move=direction=>{if(!scenes)return;const step=scenes.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(scenes).gap||0);scenes.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
 root.querySelector('[data-vg-prev]')?.addEventListener('click',()=>move(-1));
 root.querySelector('[data-vg-next]')?.addEventListener('click',()=>move(1));
 scenes?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
}
document.querySelectorAll('.vg').forEach(initVanguard);
document.addEventListener('shopify:section:load',event=>initVanguard(event.target.querySelector('.vg')));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["submi-vanguard"]) return;
  try {
    

function initVanguard(root){
 if(!root||root.dataset.vgReady)return;
 root.dataset.vgReady='true';
 const main=root.querySelector('#vg-main-image');
 root.querySelectorAll('[data-vg-gallery]').forEach(button=>button.addEventListener('click',()=>{
  main.src=button.dataset.vgGallery;main.alt=button.getAttribute('aria-label');
  root.querySelectorAll('[data-vg-gallery]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
 }));
 const dialog=root.querySelector('[data-vg-dialog]');
 root.querySelector('[data-vg-zoom]')?.addEventListener('click',()=>{const enlarged=dialog.querySelector('[data-vg-lightbox-image]');enlarged.src=main.src;enlarged.alt=main.alt;dialog.showModal();});
 root.querySelector('[data-vg-close]')?.addEventListener('click',()=>dialog.close());
 dialog?.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
 const scenes=root.querySelector('[data-vg-scenes]');
 const move=direction=>{if(!scenes)return;const step=scenes.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(scenes).gap||0);scenes.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
 root.querySelector('[data-vg-prev]')?.addEventListener('click',()=>move(-1));
 root.querySelector('[data-vg-next]')?.addEventListener('click',()=>move(1));
 scenes?.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
}
document.querySelectorAll('.vg').forEach(initVanguard);
document.addEventListener('shopify:section:load',event=>initVanguard(event.target.querySelector('.vg')));


  } catch(e) { console.error(e); }
})();
})();
